import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpRequestService } from '../shared/services/http-request.service';
import * as myGlobals from '../shared/globalcontants';
import { APIServiceProviderService } from '../shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { of as observableOf, Observable } from 'rxjs';
import { InventoryEntity } from '../shared/models/Inventory/InventoryEntity';
import { SearchHistoryEntity } from '../shared/models/Transactions/SearchHistoryEntity';
import { InventoryCollectionType } from '../shared/globalcontants';
import { InventoryCollectionEntity } from '../shared/models/Inventory/InventoryCollectionEntity';
import { RequisitionEntity } from '../shared/models/Transactions/RequisitionEntity';
import { PurchaseOrderHeaderEntity } from '../shared/models/PurchaseOrder/PurchaseOrderHeaderEntity';
import { PurchaseOrderEntity } from '../shared/models/PurchaseOrder/PurchaseOrderEntity';
import { PurchaseOrderOfflineDetailEntity } from '../shared/models/PurchaseOrder/PurchaseOrderOfflineDetailEntity';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  public selectedItem: any;
  public isPackage = false;
  public isLoadSaved = false;
  public selectedPackageItems: any = [];
  public newPurchaseOrderSelectedData: any = [];
  public unModifiedPurchaseOrder: any = [];
  public newPurchaseOrderData: any = [];
  public baseUnits = ['Pounds', 'Kgs', 'Ltr'];
  public routeStack: any = ['/purchaseOrder/purchase'];
  reqStatusList: any = ['Approved', 'Denied'];
  public isEditPurchaseOrder = false;
  public purchaseOrderFormData: any = [];
  public reqID: Number;
  public savedRequisitionDetail: RequisitionEntity;
  public savedRQADetail: PurchaseOrderEntity;
  public savedPODetail: PurchaseOrderEntity;
  public isNewPO = false;
  public offlineIconShow = false;
  public savedPOTableData: any = [];
  public POFilter: any = [];
  public POOfflineFilter: any = [];
  public newPoFilter: any = [];
  public POLoadFilter: any = [];
  public POLoadSort = '';
  public poSort: any;
  public poOfflineSort: any;
  public isShowSaveChangeAlert = false;
  public savedPOInventoryTableData: any;
  public poFormData: FormGroup;
  public savedOfflinePODetail: PurchaseOrderOfflineDetailEntity = new PurchaseOrderOfflineDetailEntity;
  InventotyLookupData: Array<any> = []
  poEditHeaderId:any;
  versionNumber:any;
  poAutoSaveVersionNo: number = 0;
  poAutoSaveSessionKey: string = null;

  constructor(private http: HttpClient, private _hs: HttpRequestService, private apiServiceProviderService: APIServiceProviderService) { }
  getInventoryDetails(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }

  getTransactionDetails(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }

  getOptionArray() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson['inventoryList']);
  }

  getPackageItem() {
   return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson.packageListItems);
  }

  /**
   * @function getRecentreacheditem(jsonPath);
   * @prams String
   * @description get the recently item list from tha local josn
   * @output Array<object>
   */

  getRecentreacheditem(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }


}
